import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_harvest-india/artifacts/ucqcpz80_IMG_0135.jpeg" 
                alt="Hind Harvest Logo" 
                className="h-12 w-12 object-contain filter brightness-0 invert"
              />
              <div className="flex flex-col">
                <span className="text-lg font-bold text-white">Hind Harvest</span>
                <span className="text-xs text-saffron-400">100% Pure</span>
              </div>
            </div>
            <p className="text-sm text-gray-400 max-w-md mb-4">
              Bringing premium FMCG products from India's unorganized sector to your doorstep. 
              Experience authentic quality with our premium saffron and curated product range.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-saffron-400 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm hover:text-saffron-400 transition-colors duration-200">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-saffron-400 transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/articles" className="text-sm hover:text-saffron-400 transition-colors duration-200">
                  Articles
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-saffron-400 transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Mail size={16} className="mt-1 text-saffron-400 flex-shrink-0" />
                <span className="text-sm">info@hindharvest.com</span>
              </li>
              <li className="flex items-start space-x-2">
                <Phone size={16} className="mt-1 text-saffron-400 flex-shrink-0" />
                <span className="text-sm">+91 (XXX) XXX-XXXX</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin size={16} className="mt-1 text-saffron-400 flex-shrink-0" />
                <span className="text-sm">India</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Hind Harvest. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;